import { createAction } from "@reduxjs/toolkit";

// Actions prefix
export const ACTIONS_NAMESPACE = "menu";

/**
 * Fetches a menu for the currently active store.
 */
export const fetchMenu = createAction(`${ACTIONS_NAMESPACE}/fetch-menu`);
